<script setup lang="ts">
import { useModalStore } from '@/modules/shared/stores/modal';
import ButtonG from '@/modules/shared/components/ButtonComponent.vue';
import { ref } from 'vue';

interface Emits {
    (e: 'submit'): void;
    (e: 'cancel'): void;
}

const store = useModalStore();
const emits = defineEmits<Emits>();

const props = defineProps({
    type: {
        type: String,
        default: 'Confirm'
    },
    color: {
        type: String,
        default: 'primary'
    },
    isDisabled: {
        type: Boolean,
        default: false
    }
});
</script>

<template>
    <div class="p-6 flex gap-2">
        <ButtonG class="w-full" hierarcy="outline" text="Cancel" @click="store.hideModal()" />

        <ButtonG :hierarcy="props.color" :text="type" class="w-full" :disabled="props.isDisabled" @click="emits('submit')" />
    </div>
</template>

<style scoped></style>
